function Log(error) {
  console.log(error);
}

const logService = {
  Log,
};

export default logService;
